import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SandboxCtx = createContext(null);
export const useSandbox = () => useContext(SandboxCtx);

export function SandboxProvider({ initialRole, children }) {
  const [role, setRoleState] = useState(localStorage.getItem("rc_role") || initialRole || "customer");
  const [sync, setSync] = useState({ offline: false, pending_sync: 0 });

  const setRole = useCallback((r) => {
    localStorage.setItem("rc_role", r);
    setRoleState(r);
  }, []);

  const refreshSync = useCallback(async () => {
    try {
      const { data } = await api.get("/sync/status");
      setSync(data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    refreshSync();
    const id = setInterval(refreshSync, 5000);
    return () => clearInterval(id);
  }, [refreshSync]);

  const processSync = async () => {
    const { data } = await api.post("/sync/process");
    await refreshSync();
    return data;
  };

  return (
    <SandboxCtx.Provider value={{ role, setRole, sync, refreshSync, processSync }}>
      {children}
    </SandboxCtx.Provider>
  );
}
